<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="通知管理" :sub-title="subTitle" @back="onBack">
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                            <FGCollapsiblePanel title="通知公告">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="24">
                                        <a-form-item label="标题" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-input ref="bt" v-model="editData.bt" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="副标题" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-input ref="fbt" v-model="editData.fbt" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="关键字" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-input ref="gjz" v-model="editData.gjz" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="接收单位类型" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <FGDictSelectCN ref="jsdwlx" dictNo="HK100102" v-model="jsdwlx" mode="multiple" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="接收单位" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-input ref="jsdws" v-model="editData.jsdws" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="有效起始日期">
                                            <a-date-picker
                                                v-model="editData.yxqsrq"
                                                width="100%"
                                                valueFormat="YYYY-MM-DD"
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="有效截止日期">
                                            <a-date-picker
                                                v-model="editData.yxjzrq"
                                                width="100%"
                                                valueFormat="YYYY-MM-DD"
                                                style="width:100%"
                                                disabled
                                                class="view"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrr" v-model="editData.lrr" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="录入日期">
                                            <a-input ref="lrrq" v-model="editData.lrrq" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="通知公告内容" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea v-model="editData.tzggnr" :rows="6" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="备注" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea v-model="editData.bz" :rows="3" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
export default {
    name: "TzggcxForm",
    props: ["showForm", "dataId", "componentName"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            isShow: false,
            jsdwlx: []
        };
    },
    computed: {
        subTitle() {
            return "查看";
        },
        // 是否显示编辑界面
        formIsVisible: {
            get() {
                return this.componentName;
            },
            set(newVal) {
                this.$emit("update:componentName", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        //附件参数
        attachCfg() {
            return {
                fktable: "OA_TZGG",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "OA1001"
            };
        },
        loading() {
            return this.editDataLoading;
        }
    },
    activated() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/oagl/tzgl/selectById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.jsdwlx = this.editData.jsdwlx.split(",");
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.formIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.formIsVisible = false;
                    }
                });
        },
        // 返回列表
        onBack() {
            this.formIsVisible = "TzggcxBrowse";
        }
    }
};
</script>
<style lang="scss" scoped>
.view {
    background: #fff;
    border: 0;
    color: #333;
    cursor: inherit;
}
.zpCls {
    width: 181px;
    height: 181px;
}
</style>
<style>
.cusBtnAlign .ant-modal-footer {
    text-align: center !important;
}
.view .ant-select-selection.ant-select-selection--single {
    background: #fff;
    border: 0px;
    cursor: inherit;
}
.view span.ant-select-arrow {
    display: none;
}
.view input.ant-calendar-picker-input.ant-input.ant-input-disabled {
    background: #fff;
    border: 0;
    color: #333;
    cursor: auto;
}
.view .ant-calendar-picker-icon {
    display: none;
    cursor: auto;
}
</style>
